/* eslint-disable */ import { entities as v1 } from './versions/v1.js';
import { entities as v2 } from './versions/v2.js';
import { entities as v3 } from './versions/v3.js';
import { entities as v4 } from './versions/v4.js';
import { entities as v5 } from './versions/v5.js';
import { entities as v6 } from './versions/v6.js';
import { entities as v7 } from './versions/v7.js';
import { entities as v8 } from './versions/v8.js';
import { entities as v9 } from './versions/v9.js';
import { entities as v10 } from './versions/v10.js';
import { entities as v11 } from './versions/v11.js';
export * from './versions/v11.js';
export const modelVersions = {
    1: v1,
    2: v2,
    3: v3,
    4: v4,
    5: v5,
    6: v6,
    7: v7,
    8: v8,
    9: v9,
    10: v10,
    11: v11
};

//# sourceMappingURL=index.js.map